import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-calendar-card]')) return;

  addEventListeners();
}

function addEventListeners() {
  const textContent = $$('[data-au-calendar-card-text]');

  textContent.forEach((text) => {
    const seeMore = document.createElement('a');
    seeMore.className = 'au-link au-calendar-card__description-link';
    seeMore.setAttribute('data-au-calendar-more', '');
    seeMore.innerText = 'Leer más';
    seeMore.href = 'javascript:void(0);';
    if (text.offsetWidth < text.scrollWidth) {
      text.closest('[data-au-calendar-card-description]').appendChild(seeMore);

      seeMore.addEventListener('click', () => {
        if (text.classList.contains('show-more')) {
          text.classList.remove('show-more');
          seeMore.innerText = 'Leer más';
        } else {
          text.classList.add('show-more');
          seeMore.innerText = 'Leer menos';
        }
      });
    }
  });

  $$('[data-au-calendar-card-link]').forEach((cardLink) => {
    cardLink.addEventListener('click', datalayerCalendarardLink);
  });
}

function datalayerCalendarardLink(e) {
  const titleText = e.target
      .closest('[data-au-calendar-card]')
      .querySelector('[data-au-calendar-card-title]').innerText,
    clickText = e.target.querySelector(':not([data-au-icon])').innerText;
  const content_type = 'clickEnlace';

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

export default { init };
